import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import Lotto56 from "@/pages/Lotto56";
import Statistik from "@/pages/Statistik";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/lotto-5d6d" element={<Lotto56 />} />
          <Route path="/statistik" element={<Statistik />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
